import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GenericUtils } from "./../../../utilities/generic-utils";
import { ApiUrlConstant } from "./../../../constants/api-url.constant";
import { MobileFilterWrapperService } from "./services/mobile-filter-wrapper-service.service";
import { LoaderService } from "@app/core/services/loader.service";
import { environment } from "@env/environment";
import { MessageService } from './../../../services/message-service';
import * as moment from "moment";

@Component({
  selector: 'app-mobile-filters-wrapper',
  templateUrl: './mobile-filters-wrapper.component.html',
  styleUrls: ['./mobile-filters-wrapper.component.scss']
})
export class MobileFiltersWrapperComponent implements OnInit, OnChanges, OnDestroy {

  @Input() dynamicFilters = [];
  @Output() filterValueEmit = new EventEmitter();
  openMobileFilter = false;
  firstTimeOpen = true;
  currentActiveFilter = {};

  dynamicForm: FormGroup;
  dynamicFormFieldConfig = {};
  status: boolean = false;
  collapsedFilter = true;
  validFilters: any = [];
  @Input() page = '';
  baseUrl = environment.gateWayHost;
  validFiltersApiCall = false;
  validFilterDataKeys = {
    "wh": "WarehouseValidFilters",
    "trp": "TransportationValidFilters"
  }


  constructor(
    private fb: FormBuilder,
    private utils: GenericUtils,
    private cd: ChangeDetectorRef,
    private apiUrlConstant: ApiUrlConstant,
    private filterWrapperService: MobileFilterWrapperService,
    private loader: LoaderService,
    private message: MessageService
  ) { }

  ngOnInit() {


    if (this.page) {
      this.getValidFilters(this.page);
    }
  }

  getValidFilters(page) {

    if (!page) return [];
    this.loader.start();
    const option = {
      method: "GET",
      url: `${this.baseUrl}${this.apiUrlConstant.VALID_FILTERS}`,
      query: { "page": page }
    };
    this.filterWrapperService
      .getValidFilters(this.utils.cleanParameters(option))
      .subscribe(
        (response: any) => {
          this.loader.stop();
          if (
            response["data"] &&
            Array.isArray(response["data"]) &&
            response["data"].length
          ) {
            if (page === 'wh') {
              this.validFilters = response["data"][0]['WarehouseValidFilters'] && response["data"][0]['WarehouseValidFilters'][0] ? response["data"][0]['WarehouseValidFilters'][0] : {}
            } else if (page === 'trp') {
              this.validFilters = response["data"][0]['TransportationValidFilters'] && response["data"][0]['TransportationValidFilters'][0] ? response["data"][0]['TransportationValidFilters'][0] : {}
            } else {
              this.validFilters = response["data"][0];
            }
          }
        },
        error => {
          this.loader.stop();
          this.validFilters = {};
        }
      );
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this.dynamicFilters.length) {
      const formFields = {};
      this.dynamicFilters.map((filter, i) => {
        filter.activeFilter = false;
        filter.filterIndex = i;
        if (i === 0) {
          filter.activeFilter = true;
          this.currentActiveFilter = filter;
        }

        this.initializeFilter(filter);
        formFields[filter.model] = [
          "",
          filter.required ? Validators.required : ""
        ];
        this.dynamicFormFieldConfig[filter.model] = filter;
      });
      // added fields to our reactive form!
      this.dynamicForm = this.fb.group(formFields);

      //Initialize our filters
      this.dynamicFilters.map((filter, i) => {
        if (filter.value) this.emitEvent(filter);
      });

    }
  }

  initializeFilter(filter) {

    if (filter.type === "drop-down") {
      if (filter.defaultValue) {
        filter.value = filter.defaultValue;
      } else {
        filter.value = filter.value ? filter.value : "";
      }
    }

    if (filter.type === "date-range") {
      const getday = moment()
        .subtract(1, "days")
        .date();

      const selected = {
        startDate: moment().subtract(getday, "days"),
        endDate: moment().subtract(filter.maxDate, "days")
      };
      const today = new Date();
      if (today.getDate() < 6) {
        selected.startDate.subtract(1, "months");
      }
      const defaultValueField = selected;


      const startDate = moment(defaultValueField.startDate).format("YYYY-MM-DD");
      const endDate = moment(defaultValueField.endDate).format("YYYY-MM-DD");

      filter.defaultValueField = defaultValueField;
      if (!filter.defaultValue && !filter.valueFromParams) {
        filter['value'] = { startDate, endDate };
      } else {
        filter['value'] = this.setValueFromParams(filter.defaultValue ? filter.defaultValue : filter.valueFromParams)
      }
    }

    if (filter.type === "autocomplete") { // not sure what to do yet here
      if (filter.config['defaultValue']) {
        const autoCompObjKeys = filter.config.display.split(" ");
        const setOfValues = filter.config['defaultValue'].split(':');
        let arrObjsInValueObject = setOfValues.map((value) => {
          const tempStr = value.trim()
          return tempStr;
        })
        arrObjsInValueObject = arrObjsInValueObject.map((keyValue, index) => {
          const keySet = autoCompObjKeys[index].split("."); // 
          let obj = {};

          for (let i = keySet.length - 1; i >= 0; i--) {
            if (i === keySet.length - 1) { obj[keySet[i]] = keyValue; }
            else {
              let tempObj = {}
              tempObj[keySet[i]] = obj;
              obj = tempObj;
            }

          }
          return obj;

        });
        const valueObject = {};

        arrObjsInValueObject.map((obj) => {
          const objectKey = Object.keys(obj)[0];
          if (valueObject[objectKey]) {
            const newObj = { ...valueObject[objectKey], ...obj[objectKey] };
            valueObject[objectKey] = newObj;
          } else {
            valueObject[objectKey] = obj[objectKey];
          }
        });
        filter.valueObject = valueObject;
        filter.value = filter.config['defaultValue'];
      }
      //  if (filter.config['defaultValue']) {
      //   let displayData = filter.config['defaultValue'];
      //   const modelValue = filter.config['defaultValue'].split('-')[0].trim();
      //   this.valueSelected = modelValue
      // }
    }

    if (filter.type === "text") {
      if (filter.defaultValue) {
        filter.value = filter.defaultValue;
      }
    }

  }
  setValueFromParams(valueFromParams) {
    let selected = {};
    Object.keys(valueFromParams).map(field => {
      if (!valueFromParams[field]) {
        selected = null;
      } else if (field.indexOf("start") > -1) {
        selected['startDate'] = valueFromParams[field];

      } else if (field.indexOf("end") > -1) {
        selected['endDate'] = valueFromParams[field];
      }
    });
    return selected
  }

  emitEvent(formField) {
    //formField is basically the filter object

    if (formField.model && this.dynamicForm.get(formField.model)) {
      this.dynamicForm.controls[formField.model].patchValue(formField.value);
      if (
        this.dynamicFormFieldConfig[formField.model] &&
        this.dynamicFormFieldConfig[formField.model]["depends"].length
      ) {
        this.dynamicFormFieldConfig[formField.model]["depends"].map(field => {
          if (this.dynamicFormFieldConfig[field]) {
            const obj = {
              [formField["filterKey"] || formField["model"]]: formField.value
            };

            this.dynamicFormFieldConfig[field]["queryParams"] = Object.assign(
              {},
              ...this.dynamicFormFieldConfig[field]["queryParams"],
              obj
            );
            this.dynamicFormFieldConfig[field]["reset"] = true;
          }
        });
      } else {
        this.dynamicFormFieldConfig[formField.model]["reset"] = false;
      }
    }
    this.cd.detectChanges();
  }
  submitForm() {
    if (!this.dynamicForm.valid) {
      return;
    }
    const filters = Object.assign({}, ...this.dynamicForm.value, {
      tell: Math.random()
    });

    const modifiedFilters = {};
    Object.keys(filters).map(value => {
      let keyset = value;
      // temporary fix for date-range

      if (keyset.indexOf("[") > -1) {
        keyset = JSON.parse(value);
      }
      if (keyset.length === 2) {
        if (filters[value] && filters[value].startDate && filters[value].endDate) {
          modifiedFilters[keyset[0]] = `${filters[value].startDate}`;
          modifiedFilters[keyset[1]] = `${filters[value].endDate}`;
        }
      } else {

        modifiedFilters[value] = filters[value] && typeof (filters[value]) == 'object' ? filters[value]['value'] : filters[value];
      }
    });
    this.collapsedFilter = !this.collapsedFilter;
    this.toggleMobileFilters();
    this.filterValueEmit.emit(this.utils.cleanParameters(modifiedFilters));
  }

  toggleMobileFilters() {
    this.firstTimeOpen = false;
    this.openMobileFilter = !this.openMobileFilter;
  }

  onLabelSelect(labelData) {
    this.currentActiveFilter = labelData;
    this.dynamicFilters.map((filter, i) => {
      filter.activeFilter = (i === labelData.filterIndex) ? true : false;
    });
  }

  resetForm() {


    for (let i = 0; i < this.dynamicFilters.length; i++) {
      if (this.dynamicFilters[i].type === "drop-down") {
        this.dynamicFilters[i].value = "";

      }
      if (this.dynamicFilters[i].type === "text") {
        this.dynamicFilters[i].value = "";
      }
      if (this.dynamicFilters[i].type === "date-range") {
        this.dynamicFilters[i].value = null;
        const startDate = moment(this.dynamicFilters[i].defaultValueField.startDate).format("YYYY-MM-DD");
        const endDate = moment(this.dynamicFilters[i].defaultValueField.endDate).format("YYYY-MM-DD");
        this.dynamicFilters[i].value = { startDate, endDate };

      }
      if (this.dynamicFilters[i].type === "autocomplete") {
        this.dynamicFilters[i].value = "";
        this.dynamicFilters[i].valueObject = null;
      }
      this.emitEvent(this.dynamicFilters[i]);
    }

    //this.message.sendMessage({ 'filterReset': true });
  }

  ngOnDestroy() {
    this.dynamicFilters = null;
    this.dynamicForm = null;
    this.dynamicFormFieldConfig = null;

  }

}
